import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { SectionHead } from "./SectionParts";
import { Sparkles } from "lucide-react";

export default function Astrology() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(0);

  useEffect(() => {
    api.get("/astrology/today")
      .then((r) => setItems(r.data || []))
      .catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section className="my-16" data-testid="astrology-section">
      <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-amber-50 via-white to-rose-50 border border-amber-100 p-8 sm:p-12">
        <div className="absolute -top-24 right-10 h-64 w-64 rounded-full bg-amber-200 opacity-50 blur-3xl" />
        <div className="absolute -bottom-32 -left-32 h-72 w-72 rounded-full bg-rose-200 opacity-40 blur-3xl" />

        <div className="relative">
          <SectionHead
            title="आज का राशिफल"
            subtitle="जानिए आपके सितारे क्या कहते हैं"
            icon={<Sparkles className="h-4 w-4" />}
          />

          <div className="grid lg:grid-cols-12 gap-6">
            <div className="lg:col-span-7 grid grid-cols-3 sm:grid-cols-4 gap-2">
              {items.map((r, i) => (
                <button
                  key={r.slug}
                  onClick={() => setActive(i)}
                  data-testid={`zodiac-${r.slug}`}
                  className={`group p-3 rounded-2xl text-center transition-all border ${
                    i === active
                      ? "bodh-gradient text-white border-transparent shadow-lg shadow-amber-200"
                      : "bg-white/70 hover:bg-white border-amber-100 text-zinc-800"
                  }`}
                >
                  <div className="text-2xl">{r.symbol}</div>
                  <div className="mt-1 font-devanagari text-xs font-bold">{r.name_hi}</div>
                </button>
              ))}
            </div>

            <div className="lg:col-span-5 rounded-2xl bg-white/80 backdrop-blur-md border border-amber-100 p-6 shadow-sm">
              <div className="flex items-center gap-3">
                <div className="h-14 w-14 rounded-2xl bg-gradient-to-br from-amber-400 to-rose-500 flex items-center justify-center text-white text-2xl shadow-lg">
                  {items[active].symbol}
                </div>
                <div>
                  <div className="font-devanagari font-black text-2xl text-zinc-900">{items[active].name_hi}</div>
                  <div className="text-xs text-zinc-500 font-outfit uppercase tracking-widest">{items[active].name_en}</div>
                </div>
              </div>
              <p className="mt-5 font-devanagari text-zinc-700 leading-relaxed">{items[active].prediction}</p>
              <div className="mt-5 flex items-center gap-2 text-xs font-hind text-zinc-500">
                <span className="px-2 py-1 rounded-full bg-amber-50 text-amber-700 font-bold">शुभ अंक: 7</span>
                <span className="px-2 py-1 rounded-full bg-rose-50 text-rose-700 font-bold">शुभ रंग: स्वर्णिम</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
